// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCYwwY9dLPpXpsd_UQUasaES0nnVJ7z6XM",
  authDomain: "clone-a8f5b.firebaseapp.com",
  projectId: "clone-a8f5b",
  storageBucket: "clone-a8f5b.appspot.com",
  messagingSenderId: "1002691087356",
  appId: "1:1002691087356:web:9c3cd6f7870f3f35834079",
  measurementId: "G-VWHT53H1WK",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebase.auth();

export { db, auth };
